import { ActionIcon, Drawer } from "@mantine/core";

import { PrimaryButton } from "_components/atoms/button";
import Icon              from "_components/atoms/icon";
import Typography        from "_components/atoms/typography";

import useStyles from "./styles";

function Information ( { opened, onClose, openCalcModal } ) {
	const { classes } = useStyles ();

	return (
		<Drawer
			classNames      = { {
				body    : classes.drawerBody,
				content : classes.drawerContent
			} }
			onClose         = { onClose }
			opened          = { opened }
			position        = { "bottom" }
			withCloseButton = { false }
			zIndex          = { 1500 }
		>
			<InnerComponent
				onClose       = { onClose }
				openCalcModal = { openCalcModal }
			/>
		</Drawer>
	);
}

function InnerComponent ( {
	onClose,
	openCalcModal
} ) {
	const { classes } = useStyles ();

	return (
		<div className = { classes.content }>
			<div className = { classes.header }>
				<Typography
					className = { classes.reportModalHeaderTitle }
					size      = { "lg" }
					title     = { "Information" }
					weight    = { 500 }
				/>

				<ActionIcon className = { classes.reportModalCloseBtn }
					onClick              = { onClose }
				>
					<Icon name = { "cross" }
						size      = { "3.6rem" }
					/>
				</ActionIcon>
			</div>

			<div className = { classes.body }>
				<div className = { classes.question }>
					<Typography
						size   = { "xs" }
						title  = "What is donation balance?"
						weight = { 500 }
					/>

					<Typography dimmed
						size  = { "xs" }
						title = "Donation balance is the amount of donation that you have received as a creator from your viewers."
					/>
				</div>

				<div className = { classes.question }>
					<Typography
						size   = { "xs" }
						title  = "How to redeem/payout donation balance?"
						weight = { 500 }
					/>

					<Typography dimmed
						size  = { "xs" }
						title = "If you have more than 100 diamonds as donation balance, you can set up auto payout, after which donation balance will automatically transfer to your desired account on the first week of every month."
					/>

					<Typography dimmed
						className = { classes.note }
						size      = { "xs" }
						title     = "Note: For Auto payout You need to have at least 100 diamonds"
					/>

				</div>

				<div className = { classes.question }>
					<Typography
						size   = { "xs" }
						title  = "What happens if you don't reach 100 diamonds in a month?"
						weight = { 500 }
					/>

					<Typography dimmed
						size  = { "xs" }
						title = "You will not get auto payout for that month, however your balance will continue to roll over each month until it reaches 100 diamonds."
					/>
				</div>

				<div className = { classes.question }>
					<Typography
						size   = { "xs" }
						title  = "How is the donation payout amount gets calculated?"
						weight = { 500 }
					/>

					<Typography dimmed
						className = { classes.link }
						onClick   = { openCalcModal }
						size      = { "xs" }
						title     = "You can view it here."
					/>
				</div>

				<PrimaryButton
					onClick = { onClose }
					size    = { "md" }
					title   = { "Okay" }
				/>

			</div>
		</div>
	);
}

export default Information;
